var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "l2s6n4mmqa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.966061 0 0 0 0 0.064079 0 0 0 0 0.164162 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hy4nv0lo3b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.050980 0 0 0 0 0.098039 0 0 0 0 0.121569 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#l2s6n4mmqa)",
    transform: "translate(-580 -598)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#hy4nv0lo3b)",
    transform: "translate(580 597)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6h12v12c0 1.105-.895 2-2 2H8c-1.105 0-2-.895-2-2V6h0z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 5.5L19 5.5M10 4.5L14 4.5",
    transform: "translate(0 1)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUserIcon);
export default __webpack_public_path__ + "static/media/delete-user-icon.b2b1fda075f1f1b215ebdd4972cf1c44.svg";
export { ForwardRef as ReactComponent };